import Table from 'admin/components/atoms/Table';
import Pager from 'admin/components/shared/Pager';
import { formatDate, formatUUID } from 'admin/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { createBadge } from '../../atoms/Badge';

const Badge = createBadge({
  ENABLED: {
    label: '有効',
  },
  DISABLED: {
    label: '無効',
    bgColor: 'grey',
  },
});

const ListTable = ({ bills, pagination, onChangePage }) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell size="1">状態</Table.Cell>
          <Table.Cell size="1">ID</Table.Cell>
          <Table.Cell size="2">発行日時</Table.Cell>
          <Table.Cell size="3">発行店舗</Table.Cell>
          <Table.Cell size="1" align="right">
            金額
          </Table.Cell>
          <Table.Cell size="4">説明文</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {bills?.map((bill) => (
          <Table.Row key={bill.id} style={{ background: bill.is_disabled ? '#ddd' : 'unset' }}>
            <Table.Cell wordBreak="keep-all">
              <Badge status={bill.is_disabled ? 'DISABLED' : 'ENABLED'} />
            </Table.Cell>
            <Table.Cell wordBreak="keep-all">
              <Link to={`/promotion/bills/${bill.id}`}>{formatUUID(bill.id)}</Link>
            </Table.Cell>
            <Table.Cell>{formatDate(bill.created_at)}</Table.Cell>
            <Table.Cell wordBreak="break-word">{bill.shop_name}</Table.Cell>
            <Table.Cell align="right">
              {bill.amount ? <span>{bill.amount.toLocaleString()}</span> : null}
            </Table.Cell>
            <Table.Cell wordBreak="break-word">{bill.description}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan="6" align="center" styles={{ paddingTop: '16px' }}>
            <Pager pagination={pagination} onChangePage={onChangePage} />
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

ListTable.propTypes = {
  bills: PropTypes.array.isRequired,
};

export default connect(null)(ListTable);
